import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 13 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 20\" id=\"icon-arrow--up\"><path d=\"M11.998 13.214q0 .145-.112.257l-.558.558q-.112.112-.257.112t-.257-.112L6.428 9.643l-4.386 4.386q-.112.112-.257.112t-.257-.112l-.558-.558q-.112-.112-.112-.257t.112-.257l5.201-5.201q.112-.112.257-.112t.257.112l5.201 5.201q.112.112.112.257z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol